import React from 'react'
import Layout from '../components/layout'
import Teamhero from '../components/wt/Teamhero'
import Teamsection2 from '../components/wt/Teamsection2'

const Team = () => (
    <Layout>
        <Teamhero />
        <Teamsection2 />
    </Layout>
)

export default Team